import { SortValue } from './CollectionDatasetSyncState';

export function compareSortArrays(
  sort1: SortValue[],
  sort2: SortValue[],
): boolean {
  if (sort1.length !== sort2.length) {
    return false;
  }

  return sort1.every((sortItem1, index) => {
    const sortItem2 = sort2[index];
    return (
      sortItem1.fieldKey === sortItem2.fieldKey &&
      sortItem1.order === sortItem2.order
    );
  });
}
